module.exports = __webpack_public_path__ + "static/img/serve8.b99c275c.png";